import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'portal-zero-state',
    templateUrl: './zero-state.component.html',
    styleUrls: ['./zero-state.component.scss'],
    standalone: false
})
export class ZeroStateComponent implements OnInit {
  @Input() title: string | SafeHtml;
  @Input() description: SafeHtml;
  @Input() tableContainer: boolean;
  @Input() compatibleCPP: boolean;
  @Input() descriptionFontSize: string;
  @Input() iconFontSize: string;
  @Input() iconSearchVisible = true;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.descriptionFontSize = this.descriptionFontSize || '1.25rem';
    this.iconFontSize = this.iconFontSize || '1.25rem';
    const snapshotData = this.activatedRoute.snapshot?.data;
    if (snapshotData?.title) {
      this.title = snapshotData.title;
    }
    if (snapshotData?.description) {
      this.description = snapshotData.description;
    }
  }
}
